module.exports = __webpack_public_path__ + "static/media/JeevRakshak.554d3bd3.png";